import { action, thunk } from 'easy-peasy';
import { Preferences } from '@capacitor/preferences';

import LocalTranslationsModel from '../interfaces/LocalTranslations';
import localeData from '../lib/translations/locales';

const model: LocalTranslationsModel = {
  language: 'en',
  messages: localeData.en,
  setLocale: action((state, payload) => {
    state.language = payload;
    Preferences.set({ key: 'locale', value: payload });
    state.messages = localeData[payload];
  }),
  loadSavedLanguage: thunk(async (actions) => {
    const lang = await Preferences.get({ key: 'locale' });
    if (lang.value === 'es' || lang.value === 'en') {
      actions.setLocale(lang.value);
    }
  }),
};

export default model;
